<template>
  <Swiper
    :modules="[SwiperAutoplay, SwiperPagination]"
    :slides-per-view="1"
    :autoplay="{
      delay: 5000,
      disableOnInteraction: false
    }"
    :loop="true"
    :pagination="paginationProps"
    @slide-change="onSlideChange"
    @autoplay-time-left="onAutoplayTimeLeft"
  >
    <SwiperSlide v-for="(slide, index) in slides" :key="index">
      <BaseCard :title="slide.title" :tag="slide.tag" :image="slide.image" :url="slide.url" :ratio="26.5 / 9" />
    </SwiperSlide>
  </Swiper>
</template>

<script setup lang="ts">
import type { PaginationOptions } from 'swiper/types'
interface Slide {
  title: string
  tag?: string
  image: string
  publish_time?: number
  weight?: number
  url: string
  display?: number // 前端过滤 0 ｜ 1
}
defineProps({
  slides: {
    type: Array as PropType<Slide[]>,
    default: () => []
  },
  ratio: {
    type: Number,
    default: 16 / 9
  }
})
defineEmits(['action'])
// const progress = ref<HTMLElement>()
const onAutoplayTimeLeft = (s: any, time: number, progress: number) => {
  const progressCircle = document.querySelector(
    '.swiper-pagination-bullet-active .swiper-pagination-bullet-svg'
  ) as HTMLElement
  progressCircle?.style.setProperty('--progress', String(1 - progress))
}
const paginationProps = ref<PaginationOptions>({
  clickable: true,
  renderBullet: function (index, className) {
    return `<div class="${className}">
              <svg viewBox="0 0 48 48" class="swiper-pagination-bullet-svg" stroke-width="4" stroke-dasharray="125.6" style="stroke-dashoffset: calc(125.6px * (1 - var(--progress)));">
                <circle cx="24" cy="24" r="20"></circle>
              </svg>
           </div>`
  }
})

const onSlideChange = () => {
  const activeBullet = document.querySelectorAll('.swiper-pagination-bullet-svg') as NodeListOf<HTMLElement>
  activeBullet.forEach((item) => {
    item.style.setProperty('--progress', '0')
  })
}
</script>
<style lang="scss">
.swiper {
  @apply relative;
}
.swiper-pagination {
  @apply bottom-20 #{!important};
}
.swiper-pagination-bullet-active {
  @apply after:bg-primary after:opacity-100 #{!important};
}

.swiper-pagination-bullet {
  @apply mx-1 h-6.5 w-6.5 bg-transparent opacity-100 #{!important};
  @apply relative inline-flex items-center justify-center;
  @apply after:h-2 after:w-2 after:rounded-full after:bg-white after:opacity-70 after:content-[''];
}

.swiper-pagination-bullet-svg {
  @apply absolute left-0 top-0 z-10 h-full w-full -rotate-90 fill-none stroke-primary;
  --progress: 0;
}
</style>
